import { render } from "./PrintersModule.vue?vue&type=template&id=1cfd8fe2&scoped=true"
import script from "./PrintersModule.vue?vue&type=script&lang=js"
export * from "./PrintersModule.vue?vue&type=script&lang=js"

import "./PrintersModule.vue?vue&type=style&index=0&id=1cfd8fe2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1cfd8fe2"

export default script